import "./AccountFlyoutAccountSwitchPage.scss";

import * as React from "react";
import { BusinessAccountResponse } from "../../../../../datatypes/businessaccounts/BusinessAccount";
import { AccountFlyoutBackButton } from "./AccountFlyoutBackButton";
import { BusinessAccountStore } from "../../../../../stores/businessaccounts/BusinessAccountStore";
import { FormattedMessage } from "react-intl";

type Props = {
    businessAccountsResponse: BusinessAccountResponse;
    setPageNumber: (pageNumber: number) => void;
    display: boolean;
};

export function AccountFlyoutAccountSwitchPage(props: Props) {
    const switchAccount = (newActiveAccountId: string) => {
        BusinessAccountStore.setActiveAccount(newActiveAccountId);
    };

    const renderCheckbox = () => {
        return (
            <div className="selectedCheckbox">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="30px"
                    height="32px"
                    viewBox="0 0 32 32"
                    version="1.1">
                    <defs>
                        <path
                            d="M13.0514,24.0001 C12.7734,24.0001 12.5064,23.8841 12.3174,23.6791 L5.2654,16.0551 C4.8904,15.6491 4.9154,15.0171 5.3214,14.6421 C5.7254,14.2661 6.3574,14.2911 6.7344,14.6971 L13.0514,21.5271 L25.2654,8.3211 C25.6404,7.9151 26.2724,7.8911 26.6784,8.2661 C27.0834,8.6411 27.1094,9.2731 26.7344,9.6791 L13.7854,23.6791 C13.5964,23.8841 13.3294,24.0001 13.0514,24.0001"
                            id="pathcheck"
                        />
                    </defs>
                    <g id="Icon" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Icon-/-medium-/-check">
                            <rect id="fill" x="0" y="0" width="32" height="32" />
                            <mask id="mask-2" fill="white">
                                <use xlinkHref="#pathcheck" />
                            </mask>
                            <use id="color" fill="#002d72" xlinkHref="#pathcheck" />
                        </g>
                    </g>
                </svg>
            </div>
        );
    };

    const renderBusinessAccount = (businessAccountResponse: BusinessAccountResponse) => {
        const accounts = businessAccountResponse.accountData;

        return accounts.map((account, index) => {
            const isActiveAccount = account.id === businessAccountResponse.activeAccountId;
            const className =
                account.id === businessAccountResponse.activeAccountId
                    ? "secondary-account-info activeUser"
                    : "secondary-account-info";
            return (
                <div key={className + index} className={className} onClick={() => switchAccount(account.id)}>
                    <a className="switchflyoutaccount switch-flyout">
                        <div className="account-info">
                            <strong>{account.corporateName}</strong>
                            <br />
                            <span>{account.address}</span>
                        </div>
                        {isActiveAccount && renderCheckbox()}
                    </a>
                </div>
            );
        });
    };
    const isPersonActive = props.businessAccountsResponse.person.id === props.businessAccountsResponse.activeAccountId;
    const className = props.display ? "secondary-flyout open" : "secondary-flyout";
    const classNameUser = isPersonActive ? "secondary-account-info activeUser" : "secondary-account-info";
    return (
        <div className={className}>
            <AccountFlyoutBackButton setPageNumber={props.setPageNumber} />
            <div className={classNameUser} onClick={() => switchAccount(props.businessAccountsResponse.person.id)}>
                <a className="switchflyoutaccount switch-flyout">
                    <div className="account-info">
                        <strong>{props.businessAccountsResponse.person.name}</strong>
                        <br />
                        <FormattedMessage id={"CIA_FLYOUT_PERSONAL_ACCOUNT"} />
                    </div>
                </a>
            </div>

            {renderBusinessAccount(props.businessAccountsResponse)}
        </div>
    );
}
